import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const CALENDAR_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/calendar',
        iconClass: 'fas fa-calendar-alt',
        name: 'Calendar',
        layout: eLayoutType.application,
        //requiredPolicy: 'AbpIdentity.Roles.Update',
        order: 1,
        group: 'User Links',
      },
    ]);
  };
}
